var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "table-component",
        {
          ref: "table",
          attrs: {
            tableDivId: _vm.tableDivId,
            "show-filter": false,
            data: _vm.fetchData,
            "table-class": "table",
          },
        },
        [
          _c("table-column", {
            attrs: {
              label: _vm.$t("accounts.company_name"),
              show: "company_name",
            },
          }),
          _vm._v(" "),
          _c("table-column", {
            attrs: { label: _vm.$t("accounts.display_name"), show: "name" },
          }),
          _vm._v(" "),
          _c("table-column", {
            attrs: { label: _vm.$t("accounts.phone"), show: "phone" },
          }),
          _vm._v(" "),
          _c("table-column", {
            attrs: {
              label: _vm.$t("accounts.added_on"),
              show: "user.formattedCreatedAt",
            },
          }),
          _vm._v(" "),
          _c("table-column", {
            attrs: {
              label: _vm.$t("accounts.status"),
              show: "user.UpperCaseStatus",
            },
          }),
          _vm._v(" "),
          _c("table-column", {
            attrs: {
              label: _vm.$t("accounts.account_type"),
              show: "user.UpperCaseAccountType",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }